import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Controller, useFormContext } from 'react-hook-form';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import { formatStr } from 'src/utils/format-time';

// Add UTC plugin to dayjs
dayjs.extend(utc);

// ----------------------------------------------------------------------

export function RHFDatePicker({ name, format, views, openTo, slotProps, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      format={format}
      views={views}
      openTo={openTo}
      render={({ field, fieldState: { error }
      }) => (
        <DatePicker
          {...field}
          value={field.value ? dayjs(field.value) : null}
          onChange={(newValue) => {
            if (newValue) {
              // Use UTC to prevent timezone issues
              field.onChange(dayjs(newValue).format('YYYY-MM-DD'));
            } else {
              field.onChange(null);
            }
          }}
          format={format || formatStr.split.date}
          views={views}
          openTo={openTo}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message ?? slotProps?.textField?.helperText,
              ...slotProps?.textField,
            },
            ...slotProps,
          }}
          {...other}
        />
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFMobileDateTimePicker({ name, slotProps, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MobileDateTimePicker
          {...field}
          value={field.value ? dayjs(field.value) : null}
          onChange={(newValue) => {
            if (newValue) {
              // Use UTC for consistent date handling
              field.onChange(dayjs(newValue).format('YYYY-MM-DD HH:mm:ss'));
            } else {
              field.onChange(null);
            }
          }}
          format={formatStr.split.dateTime}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message ?? slotProps?.textField?.helperText,
              ...slotProps?.textField,
            },
            ...slotProps,
          }}
          {...other}
        />
      )}
    />
  );
}
